const mobilDropdownItems = document.querySelectorAll('.js-dropdown-trigger');
const desktopSearch = document.querySelector('.search-container--desktop');
const navDropdown = document.querySelectorAll('.nav-main__dropdown');
const navMain = document.querySelector('.nav-main--desktop');

mobilDropdownItems.forEach(mobilDropdownItem => {
  mobilDropdownItem.onclick = function(event) {
    if (window.innerWidth < 768) {
      event.preventDefault();
      event.stopPropagation();

      const parent = mobilDropdownItem.closest('li');
      const dropdown = parent.querySelector('.nav-main__dropdown');

      dropdown.classList.toggle('open');
      desktopSearch.classList.toggle('visible');

      navMain.classList.toggle('has-open-dropdown');
    }
  }
});

document.onclick = function() {
  desktopSearch.classList.remove('visible');
  navMain.classList.remove('has-open-dropdown');
}

desktopSearch.onclick = function(event) {
  event.stopPropagation();
}

navDropdown.forEach(dropdown => {
  dropdown.onclick = function(event) {
    event.stopPropagation();
  }
});
